// extracted by mini-css-extract-plugin
module.exports = {"diagram":"styles_diagram__2EwBP","resultsOnDiag":"styles_resultsOnDiag__xNZNl"};